export * from './prizm-navigation-menu-defaults.interfaces';
